module.exports = __webpack_public_path__ + "0a20d4de4821ffc59f3c4311e722af93.svg";